<ng-content select="[app-accordion-header]"></ng-content>

<div class="app-accordion-body" [ngClass]="expanded ? 'app-accordion-expanded' : 'app-accordion-collapsed'">
  <div class="min-h-0">
    <div class="py-4">
      <ng-content></ng-content>
    </div>
  </div>
</div>
